import React from 'react'
import { Redirect } from 'react-router-dom'
import { useEffect, useSelector, useDispatch } from 'hooks'
import { fetchStaticPage } from 'store/actions'
import { TITLES } from 'common/constants'
import { isLocal } from 'config/api.config'

import StyledStaticPage from './StyledStaticPage'
import Help from './Help/Help'
import useCookies from './useCookies'

const usePage = pathname => {
  const dispatch = useDispatch()
  const lc = useSelector(s => s.account.main?.lc || 0)
  const key = `${pathname}.${lc}`

  const translations = useSelector(s => s.translations)
  const page = translations.page[key] || {}
  const heading = translations[TITLES[pathname]] || page.heading
  const loading = translations.loading || page.loading

  useEffect(() => {
    page.loaded || loading || dispatch(fetchStaticPage({ pathname, key }))
  }, [page, loading])

  return { ...page, heading, loading }
}

const StaticPage = () => {
  const path = useSelector(s => s.router.location.pathname).replace(/\/$/, '')
  const { error, content, heading, title } = usePage(path) // metaTags
  const guest = useSelector(s => !!s.myProfile.error)
  const siteName = useSelector(s => s.siteConfig.siteName)

  useEffect(() => {
    if (title) {
      document.title = title.replace(/\{%.*?%\}/g, '')
    }
    return () => (document.title = siteName)
  }, [title])

  guest && useCookies()

  if (error?.code != 404) {
    return (
      <>
        {guest && <h1 className="section-title">{heading}</h1>}
        {path == '/faq' ? (
          <Help content={content} />
        ) : (
          <StyledStaticPage dangerouslySetInnerHTML={{ __html: content }} />
        )}
      </>
    )
  }
  if (!guest) {
    return <Redirect to="/" />
  }
  if (!isLocal) {
    window.location.pathname = '/'
  }
  return null
}

export default StaticPage
